<template>

  <div style="overflow-y: auto; overflow-x: hidden;">
    <el-row :gutter="30" class="ashleys-flex-wrapper">
      <el-col :xs="24" :sm="24" :md="8" :lg="9" :xl="9" class="operator-users">
        <el-form class="table-search-form flex align-center">
          <h3 class="mr-10">USERS</h3>
          <el-input
            v-model="userSearch"
            placeholder="Search"
            class="mr-10"
            style="max-width: 200px;"
            clearable>
          </el-input>
        </el-form>
        <el-table
          v-loading="usersLoading"
          :data="userList"
          :default-sort="{prop: 'name', order: 'ascending'}"
          height="calc(100vh - 11em)"
          class="users-table">
          <el-table-column
            label=""
            width="43px">
            <template slot-scope="scope">
              <el-tooltip placement="left" :content="userTooltipStatus(scope.row)">
                <div class="avatar-group">
                  <div class="contact-avatar" v-if="scope.row.avatarPath">
                    <img :src="scope.row.avatarPath" :alt="scope.row.name" :title="scope.row.name" />
                  </div>
                  <div class="contact-avatar" v-else>
                    {{scope.row.name.substring(0,1).toUpperCase()}}
                  </div>
                  <div class="status-light">
                    <status-indicator
                      :pulse="false"
                      :status="getStatusFromEvent(scope.row.extStatus)">
                    </status-indicator>
                  </div>
                  <div class="dnd-icon" v-if="scope.row.dnd === 'on'">
                    <hr/>
                    <status-indicator></status-indicator>
                  </div>
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="name"
            label="Name"
            sortable>
          </el-table-column>
          <el-table-column
            prop="number"
            label="Number"
            sortable>
          </el-table-column>
          <el-table-column v-if="userTenantSelected" width="60px">
            <template slot-scope="scope">
              <el-button
                v-show="softphoneEnabled"
                class="table-action-button"
                v-loading="callStarting"
                @click="dialCall(scope.row.number)">
                <v-svg class="voxo-green" sprite="phone"/>
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <el-col :xs="24" :sm="24" :md="15" :lg="15" :xl="15" class="ashleys-flex">
        <el-row :gutter="30" class="panel-right operator-stats">
          <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
            <div class="card-base card-shadow--medium mb-10 widget small-widget">
              <div class="widget-header ph-20 pb-10 mb-10">
                <div class="stats-flex-body fadeInLeft">
                  <h3 class="stat-header widget-title text-truncate">
                    <v-svg width="18" height="18" class="voxo-green" sprite="call-inbound"/>
                    <span class="pl-10">ACTIVE CALLS</span>
                  </h3>
                  <h1 class="m-0 text-truncate voxo-blue text-center stat-number">{{activeCalls}}</h1>
                  <div class="stats-sub"></div>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
            <div class="card-base card-shadow--medium mb-30 widget small-widget">
              <div class="widget-header ph-20 pb-10 mb-10">
                <div class="stats-flex-body fadeInLeft">
                  <h3 class="stat-header widget-title text-truncate">
                    <v-svg width="18" height="18" class="voxo-aqua" sprite="telephone"/>
                    <span class="pl-10">EXTENSIONS</span>
                  </h3>
                  <h1 class="m-0 text-truncate voxo-blue text-center stat-number">{{usersCount}}</h1>
                  <div class="stats-sub">
                    <div class="sub-stat-group">
                      <div class="sub-stat-number">
                        {{usersCount - offlineUsers}}
                      </div>
                      <div class="sub-stat-title">
                        ONLINE
                      </div>
                    </div>
                    <div class="sub-stat-group">
                      <div class="sub-stat-number text-right">
                        {{offlineUsers}}
                      </div>
                      <div class="sub-stat-title">
                        OFFLINE
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
            <div class="card-base card-shadow--medium mb-30 widget small-widget">
              <div class="widget-header ph-20 pb-10 mb-10">
                <div class="stats-flex-body fadeInLeft">
                  <h3 class="stat-header widget-title text-truncate">
                    <v-svg width="18" height="18" class="voxo-purple" sprite="group"/>
                    <span class="pl-10">USERS:CALLS</span>
                  </h3>
                  <h1 class="m-0 text-truncate voxo-blue text-center stat-number">{{usersCount - offlineUsers - dndUsers}} : {{activeCalls}}</h1>
                  <div class="stats-sub"></div>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
        <el-row class="operator-active-calls">
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <el-form class="table-search-form flex align-center">
              <h3 class="mr-10">ACTIVE CALLS</h3>
              <el-form class="table-search-form">
                <el-form-item>
                  <el-input
                    v-model="callSearch"
                    placeholder="Search"
                    class="mr-10"
                    style="max-width: 200px;"
                    clearable>
                  </el-input>
                </el-form-item>
              </el-form>
              <div class="table-paginate flex">
                <el-pagination
                  v-if="filteredCallsCount > pageSizeCalls && !this.callSearchActive"
                  small
                  background
                  @current-change="pageSetCalls"
                  @next-click="pageNextCalls"
                  @prev-click="pagePreviousCalls"
                  layout="prev, pager, next"
                  :pager-count="5"
                  :current-page.sync="callsCurrentPage"
                  :page-size="pageSizeCalls"
                  :total="filteredCallsCount">
                </el-pagination>
                <el-tag>
                  <i class="el-icon-info" style="margin-right: 4px;"></i>
                  Total: {{ filteredCallsCount }}
                </el-tag>
              </div>

            </el-form>
            <el-table
              :data="callList"
              height="calc(100vh - 32em)"
              class="agent-calls"
              :default-sort="{prop: 'name', order: 'ascending'}">
              <el-table-column
                type="index"
                width="30"
                align="center">
              </el-table-column>
              <el-table-column
                v-if="userTenantSelected && userIsAdmin && softphoneEnabled"
                width="80px">
                <template slot-scope="scope">
                  <el-tooltip class="item" effect="dark" content="Listen" placement="left">
                    <el-button
                      class="manager-action-button"
                      :disabled="scope.row.channelState !== 'Up'"
                      @click="callSpyRequest(scope.row,false)">
                      <v-svg class="voxo-blue" sprite="eye"></v-svg>
                    </el-button>
                  </el-tooltip>
                  <el-tooltip class="item" effect="dark" content="Coach" placement="right">
                    <el-button
                      class="manager-action-button"
                      :disabled="scope.row.channelState !== 'Up'"
                      @click="callSpyRequest(scope.row,true)">
                      <v-svg class="voxo-pink" sprite="hearing"></v-svg>
                    </el-button>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column
                label="Name"
                prop="name">
              </el-table-column>
              <el-table-column
                prop="cidname"
                label="Caller Name"
                sortable>
              </el-table-column>
              <el-table-column
                prop="cidnum"
                label="Caller Number"
                :formatter="numberFormatter"
                sortable>
              </el-table-column>
              <el-table-column
                label="Duration">
                <template slot-scope="scope">
                    <span class="call-badge">
                      <el-tooltip effect="dark" content="Inbound" placement="right" v-if="scope.row.direction === 'recipient'">
                        <el-badge :value="convertTimeHold(scope.row.duration)" class="item" type="success"></el-badge>
                      </el-tooltip>
                      <el-tooltip effect="dark" content="Outbound" placement="right" v-if="scope.row.direction === 'initiator'">
                        <el-badge :value="convertTimeHold(scope.row.duration)" class="item" type="primary"></el-badge>
                      </el-tooltip>
                    </span>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>

</template>

<script>

  import {mapActions, mapGetters} from 'vuex';
  import feathersClient from "../../../feathers/feathers-client";
  import extensionStatus from "../../../ref/extension-status";
  import {globalEventBus} from "../../../globalEventBus";
  import moment from 'moment';
  import debounce from "lodash/debounce";
  import router from "@/router";
  import {phoneNumberFormatter} from "@/globals/globals";

  export default {
    name: 'OMNIAOperator',
    data() {
      return {
        statusChannel: '',
        usersLoading: true,
        callStarting: false,
        userSearch: '',
        callSearch: '',
        callSearchActive: false,
        filteringActive: false,
        activeCalls: 0,
        durationCounter: null,
        callsCurrentPage: 1,
        pageSizeCalls: 20,
        callsTotalPages: 0,
        userIsAdmin: false,
        usersCount: 0,
        filteredUsersCount: 0,
        filteredCallsCount: 0,
        userList: [],
        dndUsers: 0,
        offlineUsers: 0,
        statsPoll: null,
        callList: []
      }
    },
    computed: {
      ...mapGetters('extensions', {extensionList: 'find', getPeer: 'get'}),
      ...mapGetters('currentcalls', {findCalls: 'find'}),
      user(){
        return this.$store.state.auth.user;
      },
      selectedTenant(){
        return this.$store.state.selectedTenant;
      },
      selectedBranch(){
        return this.$store.state.activeOperatorBranch;
      },
      operatorBranches(){
        return this.$store.state.operatorBranches;
      },
      userTenantSelected(){
        if(this.user){
          if(this.user.hasOwnProperty('myExtension')){
            return this.user.myExtension.tenantId === this.selectedTenant.id;
          }
        }
        return false
      },
      userHostServer(){
        return this.$store.state.userHostServer;
      },
      softphoneEnabled(){
        return this.$store.state.softphoneEnabled;
      }
    },
    watch: {
      user(){
        if(this.user){
          this.joinSocketChannel();
        }
      },
      userSearch: debounce(function () {
        this.searchUsers()
      }, 500),
      callSearch: debounce(function (){
        this.callSearch.length ? this.populateFilteredCalls() : this.populateCalls()
      }, 500),
      selectedBranch(){
        this.loadExtensionList();
        this.populateCalls();
      },
      callsCurrentPage: debounce(function () {
        this.populateCalls();
      }, 500)
    },
    methods: {
      ...mapActions('extensions', {queryExtensions: 'find'}),
      async joinSocketChannel() {
        await feathersClient.service('channel-memberships').create({
          roomType: 'extensions',
          tenantCode: this.selectedTenant.tenantCode
        }).then( res => {
          this.statusChannel = `extensions/${this.selectedTenant.tenantCode}`;
        });
      },
      async queryUsers(){
        //query extensions and figure out branches.
        this.usersLoading = true;

        //figure out branches first
        let branchOptions = await this.queryBranches();
        this.$store.commit('setOperatorBranches', branchOptions);
        const [defaultBranchId] = await feathersClient.service('branches').find({
          query: {
            tenantId: this.selectedTenant.id,
            default: 1
          }
        });

        const defaultBranch = this.user.myExtension.tenantId === this.selectedTenant.id
          ? this.user.myExtension.branchId ? this.user.myExtension.branchId : defaultBranchId.id
          : branchOptions[0].id;
        this.$store.commit('setOperatorActiveBranch', defaultBranch);
        await this.loadExtensionList();
      },
      async loadExtensionList(){
        this.usersLoading = true;
        this.$store.commit('extensions/clearList');
        this.queryExtensions({
          query: {
            queryPhonebook: true,
            excludeNotInPb: true,
            tenantId: this.selectedTenant.id,
            branchId: this.selectedBranch
          }
        }).then(res => {
          this.usersCount = res.length;
          this.populateUsers();
          this.getActiveCalls();
          this.updatePolledStats();
        });
      },
      async queryBranches(){
        if(this.userIsAdmin){
          return await feathersClient.service('branches').find({
            query: {
              tenantId: this.selectedTenant.id,
              $sort: {
                name: 1
              }
            }
          })
        }
        if(!this.userIsAdmin){
          return this.user.myExtension.branchId ? [await feathersClient.service('branches').get(this.user.myExtension.branchId)] : []
        }
      },
      getActiveCalls(){

        //these are already in the store
        const storeCalls = this.findCalls().data;
        for(let i = 0; i < storeCalls.length; i++){
          const {channel, peername} = storeCalls[i];
          let user = this.getPeer(peername);
          if (user) {
            this.$store.commit('currentcalls/updateItem', {channel, branch: user.branchId, name: user.name})
          }
        }

        //all the peerNames available in the store for active channels.
        const peerNames = [...this.$store.state.extensions.ids];

        feathersClient.service('nats-actions-handler').create({
          reqType: 'refreshConnectedCalls',
          hostServer: this.userHostServer,
          peerName: this.user.myExtension.peerName,
          panelTenantCode: this.selectedTenant.tenantCode,
          tenantCode: this.selectedTenant.tenantCode,
          tenantId: this.selectedTenant.id,
          userId: this.user.id,
          userExten: this.user.myExtension.number,
          peerNames
        }).then( channels => {
          const callCount = channels.length;
          let callDataArray = [];
          for(let i = 0; i < callCount; i++){
            const theChannel = channels[i];
            if (!this.checkCallExists(theChannel)) {
              const {channel, exten, connectedlinenum, connectedlinename, direction, timestamp, hostName, peerName, channelstatedesc, application} = theChannel;
              let user = this.getPeer(peerName);

              if(connectedlinenum.includes("SPY") || connectedlinenum.includes("WHISPER")){
                continue;
              }

              if (user && application !== "ChanSpy") {
                const foundMember = user;
                if(connectedlinenum.length){
                  const callData = {
                    name: foundMember.name,
                    branch: foundMember.branchId,
                    channel,
                    cidnum: connectedlinenum,
                    cidname: connectedlinename,
                    direction,
                    peername: peerName,
                    systemname: hostName,
                    channelState: channelstatedesc,
                    duration: moment().unix() - timestamp,
                    application
                  };
                  callDataArray.push(callData);
                }
              }
            }
          }
          if(callDataArray.length){
            this.$store.commit('currentcalls/addItems', callDataArray);
          }
          this.populateCalls();
        });
      },
      userTooltipStatus(user){
        if(user.dnd === 'on'){
          return 'Do Not Disturb'
        }
        if(user.extStatus === 'NOT_INUSE'){
          return 'Idle'
        }
        if(user.extStatus === 'INUSE'){
          return 'On A Call'
        }
        if(user.extStatus === 'RINGING'){
          return 'Ringing'
        }
        if(user.extStatus === 'UNAVAILABLE'){
          return 'Offline';
        }
        if(!user.extStatus){
          return 'Offline';
        }
        return 'Status Unknown';
      },
      getStatusFromEvent(code) {
        return extensionStatus(code)
      },
      numberFormatter(row, column, value) {
        return phoneNumberFormatter(value);
      },
      convertTimeHold(time) {
        const hours = Math.floor(time / 3600);
        const remainderSeconds = time % 3600;
        const minutes = Math.floor(remainderSeconds / 60);
        const seconds = Math.round(remainderSeconds % 60);

        if (hours > 0) {return hours + 'hr ' + minutes + 'm';}
        if (minutes > 0) {return minutes + 'm ' + seconds + 's';}
        if (seconds > 0) {return seconds + 's';}
        return '0';
      },
      durationInSeconds(value){
        const durationParts = value.split(':');
        const hours = +durationParts[0];
        const minutes = +durationParts[1];
        const seconds = +durationParts[2];
        return hours*3600 + minutes*60 + seconds;
      },
      filteredCalls() {
        return this.currentCallList.filter(data => !this.callSearch
          || data.cidname.toLowerCase().includes(this.callSearch.toLowerCase())
          || data.cidnum.toLowerCase().includes(this.callSearch.toLowerCase())
          || data.name.toLowerCase().includes(this.callSearch.toLowerCase())
        )
      },
      checkCallExists(item){
        const queryCall = this.findCalls({query: {channel: item.channel}}).data;
        return !!queryCall.length;
      },
      pushedConnected(item){

        if(item.cidnum.includes('SPY') || item.cidnum.includes('WHISPER')){
          return false;
        }

        if(item.status === 'INUSE' && item.direction.length){
          if(item.cidnum === '' || item.cidnum === '<unknown>'){
            return false;
          }
          return item.cidnum.substr(0, 1) !== '*';
        }
        return false;
      },
      updateHoldTimes() {
        const connectedCallers = this.findCalls().data;
        const storeCommit = connectedCallers.map( item => { return {
          channel: item.channel,
          duration: +item.duration + 1
        }});
        if(storeCommit.length){
          this.$store.commit('currentcalls/updateItems', storeCommit);
        }
      },
      callSpyRequest(call, whisper){
        const {channel, peername} = call;
        const splitChannel = channel.split('-');
        const channelPrefix = `${splitChannel[0]}-${splitChannel[1]}-`;

        const extension = peername.split('-')[0];
        const tenantCode = peername.split('-')[1];

        if(this.softphoneEnabled){
          if(whisper){
            globalEventBus.$emit('dialSoftphone', `*5${extension}`);
          } else{
            globalEventBus.$emit('dialSoftphone', `*6${extension}`);
          }
        } else{
          const extensionNumber = this.user.myExtension.number;
          const channelName = `Local/${extensionNumber}@authenticated`;
          let reqBody = {
            reqType: 'spy',
            whisper,
            channelName,
            account: this.user.myExtension.tenantCode,
            channelPrefix,
            callerId: extensionNumber,
            tenantCode,
            hostServer: this.userHostServer
          };
          feathersClient.service('nats-actions-handler').create(reqBody);
        }

        //listen / coach user event
        this.$store.dispatch('userEvents/create', {
          event: whisper ? 'Coach' : 'Listen',
          extension
        })
      },
      dialCall(exten){
        if(this.softphoneEnabled){
          globalEventBus.$emit('dialSoftphone', exten);
        } else{
          const {number, callerId, tenantCode, name} = this.user.myExtension;
          this.callStarting = true;
          feathersClient.service('nats-actions-handler').create({
            reqType: 'dial',
            extension: number,
            callerId,
            name,
            dest: exten,
            tenantCode,
            hostServer: this.userHostServer
          }).then( () => {this.callStarting = false});
        }
      },
      removeListeners(){
        const channelMemberships = feathersClient.service('channel-memberships');
        channelMemberships.removeListener('extensionStatus');
        channelMemberships.removeListener('notifyExtStatus');
        globalEventBus.$off('appReconnected');
      },
      populateUsers(){
        const users = this.extensionList({
          query: {
            $sort: {
              name: 1
            },
            $limit: 50
          }
        });

        this.userList = users.data;
        this.usersLoading = false;
      },
      searchUsers(){
        this.usersLoading = true;
        if(this.userSearch){
          const extList = this.extensionList().data;
          const filteredUsers = extList.filter(data => !this.userSearch
            || data.name.toLowerCase().includes(this.userSearch.toLowerCase())
            || data.number.toLowerCase().includes(this.userSearch.toLowerCase()));
          this.userList = filteredUsers.slice(0,50);
        } else{
          this.populateUsers();
        }

        this.usersLoading = false;
      },
      pageNextCalls () {
        if (this.callsCurrentPage < this.callsTotalPages) {
          this.callsCurrentPage += 1;
        }
      },
      pagePreviousCalls () {
        if (this.callsCurrentPage > 1) {
          this.callsCurrentPage -= 1;
        }
      },
      pageSetCalls (page) {
        this.callsCurrentPage = page;
      },
      updatePolledStats(){

        //polls for users online and dnd
        const dndUsers = this.extensionList({
          query: {
            extStatus: {$ne: 'UNAVAILABLE'},
            dnd: 'on'
          }
        }).data;
        this.dndUsers = dndUsers.length;

        //polls for users offline
        const offlineUsers = this.extensionList({
          query: {
            extStatus: 'UNAVAILABLE'
          }
        }).data;
        this.offlineUsers = offlineUsers.length;

        //polls for active call stuff
        this.callSearchActive ? this.populateFilteredCalls() : this.populateCalls()

      },
      populateCalls(){
        this.callSearchActive = false;
        const calls = this.findCalls({
          query: {
            branch: this.selectedBranch,
            $limit: this.pageSizeCalls,
            $skip: this.callsCurrentPage > 1 ? (this.pageSizeCalls * (this.callsCurrentPage - 1)) : 0,
          }
        });
        this.callsTotalPages = Math.ceil(calls.total / calls.limit);
        this.callList = calls.data;
        this.activeCalls = calls.total;
        this.filteredCallsCount = calls.total;
        if(this.filteredCallsCount <= this.pageSizeCalls){
          this.callsCurrentPage = 1;
        }
      },
      populateFilteredCalls(){
        this.callSearchActive = true;
        const calls = this.findCalls({
          query: {
            branch: this.selectedBranch
          }
        });
        const filteredCalls = calls.data.filter(data => !this.callSearch
          || data.cidname.toLowerCase().includes(this.callSearch.toLowerCase())
          || data.cidnum.toLowerCase().includes(this.callSearch.toLowerCase())
          || data.name.toLowerCase().includes(this.callSearch.toLowerCase())
        );
        this.callList = filteredCalls;
        this.filteredCallsCount = filteredCalls.length;
        if(this.filteredCallsCount <= this.pageSizeCalls){
          this.callsCurrentPage = 1;
        }
        this.activeCalls = calls.total;
      },
      allowOperator() {
        if (this.user) {
          const { enableOperatorPanel } = this.user;
          const { isResidential } = this.user.myExtension;
          return (enableOperatorPanel && !isResidential);
        }
        return false;
      },
    },
    mounted(){
      if(!this.allowOperator()) {
        this.$router.push("/omnia/contacts");
        return;
      }
      const channelMemberships = feathersClient.service('channel-memberships');
      this.$store.commit('setOperatorMode', true);

      if(this.user){
        this.joinSocketChannel();
      }

      const adminRoles = [1,3,11,12];
      this.userIsAdmin = adminRoles.includes(+this.user.userRole);
      this.queryUsers();

      //this is a counter to update the hold times for each caller in line
      this.durationCounter = setInterval(this.updateHoldTimes, 1000);
      this.statsPoll = setInterval(this.updatePolledStats, 2000);

      channelMemberships.on('extensionStatus', evt => {
        const {status, channel, cidname, peername, ishangup, event, channelState} = evt;
        const user = this.getPeer(peername);

        //update caller information if this is a parking pick up.
        if(event === 'ParkPickup'){
          const theCall = [...this.findCalls({query: {cidnum: evt.parkingSpace}}).data];
          if(theCall.length){
            const channel = theCall[0].channel;
            this.$store.commit('currentcalls/updateItem', {channel, cidname: evt.cidname, cidnum: evt.cidnum})
          }
          return;
        }

        if(ishangup){
          this.$store.commit('currentcalls/removeItem', evt.channel);
        } else{
          const callExists = this.checkCallExists(evt);
          if(this.pushedConnected(evt)){
            if(callExists){
              const updateData = {
                channel,
                cidname: cidname === '<unknown>' ? 'Unknown' : cidname,
                name: user ? user.name : '',
                branch: user ? user.branchId : '',
                channelState
              };
              this.$store.commit('currentcalls/updateItem', updateData);
            } else {
              this.$store.commit('currentcalls/addItem', {duration: 0, ...evt, name: user ? user.name : '', branch: user ? user.branchId : ''});
            }
          }
        }

        if(user){
          this.$store.commit('extensions/updateItem', {peerName: peername, extStatus: status});
          if(!evt.direction.length){
            this.$store.commit('extensions/updateItem', {peerName: peername, dnd: evt.dnd})
          }
        }
      });

      //listens for updates to extension availability
      channelMemberships.on('notifyExtStatus', item => {
        const {peerName, status} = item;
        const updateData = {
          peerName
        };
        if (status === 'UNAVAILABLE') {
          updateData.extStatus = 'UNAVAILABLE';
        } else{
          updateData.extStatus = 'NOT_INUSE';
        }
        this.$store.commit('extensions/updateItem', updateData);
      });

      //monitor socket connection and reconnect to channel
      globalEventBus.$on('appReconnected', async () => {
        console.log('the app did reconnect');
        await this.joinSocketChannel();
        if(this.user.hasOwnProperty('myExtension')){
          //this will bust the current connected calls and call a service to refresh the list
          this.$store.commit('currentcalls/clearList');
          this.getActiveCalls();
        }
      });
    },
    beforeDestroy() {
      const channelMemberships = feathersClient.service('channel-memberships');

      //leave the status channel if the tenant doesn't match user tenant
      channelMemberships.remove(null, {query: {channelName: this.statusChannel}});
      this.$store.commit('setOperatorMode', false);
      this.$store.commit('extensions/clearList');
      this.$store.commit('currentcalls/clearList');
      clearInterval(this.durationCounter);
      clearInterval(this.statsPoll);
      this.removeListeners();
    }
  }

</script>

<style lang="scss" scoped>

  .manager-action-button{
    width: 28px;
    height: 28px;
    padding: 1px;
    svg{
      width:16px;
      margin: 1px 0px 0 0;
    }
  }

  .status-light, .dnd-icon{
    right: -4px;
  }

  .stat-number{
    font-size: 3em;
  }

  .stat-header{
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1em;
    padding-bottom: 5px;
  }

  .stats-sub{
    display: flex;
    justify-content: space-between;
    align-self: flex-end;
    height: 45px;
  }

  .stats-flex-body{
    height: 200px;
    display: flex;
    flex-wrap: wrap;
    >*{
      flex-basis: 100%;
    }
  }

  .sub-stat-number{
    font: {
      weight: bold;
    }
  }

  .sub-stat-title{
    font-size: 0.85em;
  }

  .call-badge{
    float: none;
  }

  .el-form{
    .el-form-item{
      max-width: 300px;
      margin-bottom: 5px;
    }
  }

  .panel-right {
    margin-top: 42px;
  }

  .form-section-header{
    margin-top: 0;
    margin-bottom: 4px;
  }

  @media (max-width: 1000px){

    .ashleys-flex-wrapper{
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      >*{
        flex-basis: 100%;
      }
      .operator-users{
        order: 2;
      }
    }

    .ashleys-flex{
      order: 1;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      >*{
        flex-basis: 100%;
      }
      .operator-stats{
        order: 2;
      }
      .operator-active-calls{
        order: 1;
      }
    }
  }

  .table-paginate{
    margin-left: auto;
  }

  @media (max-width: 1260px){
    .table-search-form{
      flex-wrap: wrap;
      >*{
        flex-basis: 100%;
      }
    }
    .table-paginate{
      margin-left: 0;
    }
    .el-tag{
      margin-left: auto;
    }
    .el-input{
      margin-bottom: 5px;
    }
  }



</style>

